import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
// Vueコンポーネントの遅延読み込み
function loadView(view) {
  return () =>
    import(/* webpackChunkName: "view-[request]" */ `@/views/${view}.vue`);
}
const router = new Router({
  routes: [
    // メタサイト組み立てページ
    {
      path: '/',
      name: 'TopView',
      component: loadView('TopView')
    },
    // // リアルバーチャル(テンアップ)メタサイト
    // {
    //   path: '/tenup',
    //   name: 'tenup',
    //   component: loadView('TenupView')
    // },
    // リアルバーチャル メタサイト
    {
      path: '/real-virtual',
      name: 'real-virtual',
      component: loadView('RealVirtualView')
    },
    {
      path: '/real-virtual/:page',
      name: 'real-virtual-page',
      component: loadView('RealVirtualView')
    },
    // リアルバーチャル メタサイト イベント入口
    {
      path: '/rv',
      name: 'rv',
      component: loadView('RvView')
    },
    // 花火大会2024 メタサイト
    {
      path: '/rv_fws2024',
      name: 'rv_fws2024',
      component: loadView('RvFws2024View')
    },
    // サンプル花火大会360動画
    {
      path: '/ff-demo',
      name: 'ff-demo',
      component: loadView('FfDemoView')
    },
    {
      path: '/ff-demo/:page',
      name: 'ff-demo-page',
      component: loadView('FfDemoView')
    },
    // rv2024 メタサイト
    {
      path: '/rv2024',
      name: 'rv2024',
      component: loadView('Rv2024View')
    },
    // イベント メタサイト
    {
      path: '/event',
      name: 'event',
      component: loadView('EventView')
    },
    // 結婚式場 メタサイト
    {
      path: '/wedding-demo',
      name: 'wedding-demo',
      component: loadView('WeddingDemoView')
    },
    {
      path: '/wedding-demo2',
      name: 'wedding-demo2',
      component: loadView('WeddingDemo2View')
    },
    // プール メタサイト
    {
      path: '/pool',
      name: 'pool',
      component: loadView('PoolView')
    },
    // サーフィン大会 デモ メタサイト
    {
      path: '/surf-test',
      name: 'surf-test',
      component: loadView('SurfTestView')
    },
    // フェス デモ メタサイト
    {
      path: '/fes-test',
      name: 'fes-test',
      component: loadView('FesTestView')
    },
    // 富士通スポーツ デモ メタサイト
    {
      path: '/fjsports-sample',
      name: 'fjsports-sample',
      component: loadView('FjsportsSampleView')
    },
    // 富士通スポーツ2 デモ メタサイト
    {
      path: '/fjsports-sample2',
      name: 'fjsports-sample2',
      component: loadView('FjsportsSample2View')
    },
    // 乃村工藝社 デモ メタサイト
    {
      path: '/nomurakougei-1',
      name: 'nomurakougei-1',
      component: loadView('Nomurakougei1View')
    },
    // VRschool 1 デモ メタサイト
    {
      path: '/vrschool-test1',
      name: 'vrschool-test1',
      component: loadView('VrschoolTest1View')
    },
    // VRschool 2 デモ メタサイト
    {
      path: '/vrschool-test2',
      name: 'vrschool-test2',
      component: loadView('VrschoolTest2View')
    },
    // テスト 天球の中に天球 メタサイト
    {
      path: '/test',
      name: 'test',
      component: loadView('TestView')
    },
    // conferenceサイト
    {
      path: '/confelence',
      name: 'confelence',
      component: loadView('ConfelenceView')
    },
    // 東京農大 北海道オホーツクキャンパス
    {
      path: '/nodai-okhotsk',
      name: 'nodai-okhotsk',
      component: loadView('NodaiOkhotskView')
    },
    {
      path: '/nodai-okhotsk/:page',
      name: 'nodai-okhotsk-page',
      component: loadView('NodaiOkhotskView')
    },
    // 東京農大 メタサイト
    {
      path: '/nodai',
      name: 'nodai',
      component: loadView('NodaiView')
    },
    {
      path: '/nodai/:page',
      name: 'nodai-page',
      component: loadView('NodaiView')
    },
    // ウィルオブワーク メタサイト
    {
      path: '/willof-work',
      name: 'willof-work',
      component: loadView('WillOfWorkView')
    },
    {
      path: '/willof-work/:page',
      name: 'willof-work-page',
      component: loadView('WillOfWorkView')
    },
    // みどりの感謝祭 メタサイト
    // {
    //   path: '/midorinokanshasai',
    //   name: 'midorinokanshasai',
    //   component: loadView('MidorinokanshasaiView')
    // },
    // ギャラクシー スタッフ用 メタサイト
    // {
    //   path: '/galaxy-staff',
    //   name: 'galaxy-staff',
    //   component: loadView('GalaxyStaffView')
    // },
    // {
    //   path: '/galaxy-staff/:page',
    //   name: 'galaxy-staff-page',
    //   component: loadView('GalaxyStaffView')
    // },
    // 明蓬館 メタサイト
    {
      path: '/meihokan',
      name: 'meihokan',
      component: loadView('MeihokanView')
    },
    {
      path: '/meihokan/:page',
      name: 'meihokan-page',
      component: loadView('MeihokanView')
    },
    // アイネス メタサイト
    {
      path: '/ines',
      name: 'ines',
      component: loadView('InesView')
    },
    {
      path: '/ines/:page',
      name: 'ines-page',
      component: loadView('InesView')
    },
    // 三菱総研 メタサイト
    {
      path: '/mri_202407',
      name: 'mri_202407',
      component: loadView('Mri202407View')
    },
    // 三菱総研2026 メタサイト
    {
      path: '/mri_2026',
      name: 'mri_2026',
      component: loadView('Mri2026View')
    },
    // 学研(バーチャル水族館) メタサイト
    {
      path: '/aquarium-gakken',
      name: 'aquarium-gakken',
      component: loadView('AquariumGakkenView')
    },
    // 日本大学 メタサイト
    {
      path: '/brs-nihon-u',
      name: 'brs-nihon-u',
      component: loadView('BrsNihonUView')
    },
    // 日本大学 日本大学生物資源科学部 メタサイト
    {
      path: '/brs-nihon',
      name: 'brs-nihon',
      component: loadView('BrsNihonView')
    },
    {
      path: '/brs-nihon/:page',
      name: 'brs-nihon-page',
      component: loadView('BrsNihonView')
    },
    // MIT メタサイト
    {
      path: '/mit',
      name: 'mit',
      component: loadView('MitView')
    },
    // 代々木ゼミナール メタサイト
    {
      path: '/yozemi',
      name: 'yozemi',
      component: loadView('YozemiView')
    },
    {
      path: '/yozemi/:page',
      name: 'yozemi-page',
      component: loadView('YozemiView')
    },
    // 立命館大学 メタサイト
    {
      path: '/ritsumei',
      name: 'ritsumei',
      component: loadView('RitsumeiView')
    },
    // 成蹊大学 メタサイト
    {
      path: '/seikei',
      name: 'seikei',
      component: loadView('SeikeiView')
    },
    // ブックハウスカフェ メタサイト
    {
      path: '/bookhousecafe',
      name: 'bookhousecafe',
      component: loadView('BookhousecafeView')
    },
    // 登校支援 メタサイト
    {
      path: '/toukoushien',
      name: 'toukoushien',
      component: loadView('ToukoushienView')
    },
    // 近畿大学 メタサイト
    {
      path: '/kindai',
      name: 'kindai',
      component: loadView('KindaiView')
    },
    // Yoshimi Saito メタサイト
    {
      path: '/yoshimisaito',
      name: 'yoshimisaito',
      component: loadView('YoshimiSaitoView')
    },
    // 八千代市の入口 メタサイト
    {
      path: '/yachiyo-ed',
      name: 'yachiyo-ed',
      component: loadView('YachiyoEdView')
    },
    {
      path: '/yachiyo-ed/:page',
      name: 'yachiyo-ed-page',
      component: loadView('YachiyoEdView')
    },
    // 乃村工藝 メタサイト
    {
      path: '/nomurakougei',
      name: 'nomurakougei',
      component: loadView('NomurakougeiView')
    },
    {
      path: '/nomurakougei/:page',
      name: 'nomurakougei-page',
      component: loadView('NomurakougeiView')
    },
    // JAL メタサイト
    {
      path: '/jal-test',
      name: 'jal-test',
      component: loadView('JalTestView')
    },
    {
      path: '/jal-test/:page',
      name: 'jal-test-page',
      component: loadView('JalTestView')
    },
    // First Toys メタサイト
    {
      path: '/firsttoys',
      name: 'firsttoys',
      component: loadView('FirsttoysView')
    },
    {
      path: '/firsttoys/:page',
      name: 'firsttoys-page',
      component: loadView('FirsttoysView')
    },
    // // メタサイトオリジナルデータ
    // {
    //   path: '/original',
    //   name: 'OriginalView',
    //   component: loadView('OriginalView')
    // },
    {
      path: '*',
      redirect: '/'
    }
  ]
});

export default router;